(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[69639],{

/***/ 66202:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payrollsystems",
      function () {
        return __webpack_require__(61640);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ PayrollSystemsHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_payrollsystems_mainBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8758);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);
/* harmony import */ var _components_layouts_payrollSystemsWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12991);






const OffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 33124).then(__webpack_require__.bind(__webpack_require__, 33124)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33124)
            ]
    }
});
const WhyUs = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 3125).then(__webpack_require__.bind(__webpack_require__, 3125)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3125)
            ]
    }
});
var __N_SSP = true;
function PayrollSystemsHome() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_payrollSystemsWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_payrollsystems_mainBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OffersList, {
                    offers: domain?.defaultOffers
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WhyUs, {})
        ]
    });
}


/***/ }),

/***/ 8758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96119);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55317);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _styles_variables_payrollsystemsVariables_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69011);
/* harmony import */ var _styles_variables_payrollsystemsVariables_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_payrollsystemsVariables_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_shared_combinedForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31095);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);







function MainBanner() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__/* .useDomainContext */ .w)();
    return domain.categories?.length === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["main-banner"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            classes: {
                formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().form),
                stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["step-title"]),
                stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["step-description"]),
                formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["form-button"]),
                formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["form-field"]),
                formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["steps-inner"]),
                fieldsClassName: {
                    radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["radio-field"])
                },
                fieldsWrapperClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["fields-wrapper"]),
                tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().tcpa),
                labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["label-as-step-title"]),
                formProgressbarClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["progress-background"])
            },
            colors: {
                primaryColor: (_styles_variables_payrollsystemsVariables_module_scss__WEBPACK_IMPORTED_MODULE_6___default().defaultButtonColor),
                progressBar: (_styles_variables_payrollsystemsVariables_module_scss__WEBPACK_IMPORTED_MODULE_6___default().defaultProgressColor)
            },
            showProgress: true
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_combinedForm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        formClasses: {
            // formClassName: `${styles["form"]}`,
            stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["step-title"]),
            stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["step-description"]),
            formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["form-button"]),
            formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["form-field"]),
            formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["steps-inner"]),
            fieldsClassName: {
                radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["radio-field"]),
                checkbox: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["checkbox-field"])
            },
            fieldsWrapperClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["fields-wrapper"]),
            tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().tcpa),
            labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["label-as-step-title"]),
            formProgressbarClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["progress-background"])
        },
        blockContainerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["blocks-container"]),
        blockClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["category-block"]),
        mainBannerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["main-banner"]),
        primaryColor: "#006336",
        colors: {
            primaryColor: (_styles_variables_payrollsystemsVariables_module_scss__WEBPACK_IMPORTED_MODULE_6___default().defaultButtonColor),
            progressBar: (_styles_variables_payrollsystemsVariables_module_scss__WEBPACK_IMPORTED_MODULE_6___default().defaultProgressColor)
        },
        backButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["back-button"]),
        title: "HR Solutions to Fuel Your Business Growth",
        description: "By streamlining your workflow, you'll have more time to concentrate on expanding your company. Fill out our form now to find the perfect service for you.",
        showArrows: true,
        resetLeadId: true
    });
}


/***/ }),

/***/ 55317:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","main-banner":"styles_main-banner__PaEzq","image":"styles_image__jA5ug","back-button":"styles_back-button__ja3CN","form":"styles_form__WSD8t","steps-inner":"styles_steps-inner__9_LlX","step-title":"styles_step-title__VBfHq","label-as-step-title":"styles_label-as-step-title___9FVb","step-description":"styles_step-description__y8bk_","fields-wrapper":"styles_fields-wrapper__Fu8oZ","form-button":"styles_form-button___1C88","form-field":"styles_form-field__K1Edu","checkbox-field":"styles_checkbox-field__kMW02","radio-field":"styles_radio-field__Wr4Uq","tcpa":"styles_tcpa__j0Rtm","progress-background":"styles_progress-background__Pv6x_","blocks-container":"styles_blocks-container__1Q5Kp","category-block":"styles_category-block__uAiD5"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,63302,12991,45242,49774,92888,40179], function() { return __webpack_exec__(66202); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);